// 프로젝트 유형 데이터 타입 정의
import { projectTypeApi } from '../services/api';

export interface ProjectTypeItem {
  title: string;
  children: { id: string; label: string }[];
}

// 기본 프로젝트 유형 데이터
export const defaultProjectTypeData: ProjectTypeItem[] = [
  {
    title: "영상",
    children: [
      { id: "check1_1", label: "방송프로그램" },
      { id: "check1_2", label: "홍보영상" },
    ],
  },
  {
    title: "디지털 콘텐츠",
    children: [
      { id: "check2_1", label: "유튜브 영상" },
      { id: "check2_2", label: "온라인 콘텐츠" },
      { id: "check2_3", label: "SNS 운영" },
      { id: "check2_4", label: "이모티콘 제작" },
      { id: "check2_5", label: "웹툰" },
      { id: "check2_6", label: "SNS 이벤트" },
      { id: "check2_7", label: "애니메이션" },
      { id: "check2_8", label: "인스타툰" },
    ],
  },
  {
    title: "오프라인",
    children: [{ id: "check3_1", label: "오프라인 행사" }],
  },
];

// 프로젝트 유형 데이터 관리 함수들 (서버 API 사용)
export const getProjectTypeData = async (): Promise<ProjectTypeItem[]> => {
  try {
    return await projectTypeApi.getProjectTypeData();
  } catch (error) {
    console.error('프로젝트 유형 데이터 조회 오류:', error);
    return defaultProjectTypeData;
  }
};

export const saveProjectTypeData = async (data: ProjectTypeItem[]): Promise<void> => {
  try {
    await projectTypeApi.saveProjectTypeData(data);
  } catch (error) {
    console.error('프로젝트 유형 데이터 저장 오류:', error);
    throw error;
  }
};

export const resetProjectTypeData = (): void => {
  localStorage.removeItem('projectTypeData');
};

// ID 생성 헬퍼 함수
export const generateProjectTypeId = (groupIndex: number, itemIndex: number): string => {
  return `check${groupIndex + 1}_${itemIndex + 1}`;
}; 